import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "assets-h5-header"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_nav_bar = _resolveComponent("nav-bar");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_nav_bar, {
    title: $props.title,
    "left-text": "返回",
    "left-arrow": "",
    onClickLeft: $setup.onClickLeft
  }, null, 8, ["title", "onClickLeft"])]);
}